import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { BasicContextInteface, IProduct } from '../interfaces/User.interface';
import { IBooking } from '../interfaces/Booking.interface';
import { useLoading } from './LoadingContext';
import { useAuth } from './AuthContext';
import { useFetch } from '../utils/FetchTemplate';

const BookingContext = createContext<{
    bookings: IBooking[],
    setBookings?: React.Dispatch<React.SetStateAction<IBooking[]>>,
    fetchBookings: () => Promise<void>

}>({
    bookings: [],
    setBookings: () => {},
    fetchBookings: () => Promise.resolve()
  });

export const BookingsProvider: React.FC<BasicContextInteface> = ({ children }) => {

    const [bookings, setBookings] = useState<IBooking[]>([]);
    const { loggedIn, logout } = useAuth();
    const { postData, getData } = useFetch()
    
    const fetchBookings = async () => {
      if (!loggedIn) return;
      getData<IBooking[]>('/api/booking/list').then((bookings) => {
        setBookings(bookings);
      }).catch().finally(() =>{
      })
    };
      
    useEffect(() => {
        fetchBookings();
    }, [loggedIn]);


    return (
        <BookingContext.Provider value={ { bookings, fetchBookings,setBookings } }>
            {children}
        </BookingContext.Provider>
    );
};

export const useBookings = () => useContext(BookingContext);

